import { find } from 'lodash';
import { IAuthenticateUserResponse, ITenantFeatures } from '../interface/Auth.interface';
import { getAuthUser } from '../api/apiContext';

export const hasModuleEnabledForLoggedInUser = (module: string) => {
	//console.log('Called', module);
	const authUser: IAuthenticateUserResponse = getAuthUser();
	return hasModuleEnabled(authUser?.tenantFeatures, module);
};

export const hasModuleEnabled = (features: ITenantFeatures[], module: string) => {
	const feature = find(features, { module }) as ITenantFeatures | undefined;
	console.log('Feature', feature);
	return feature?.enabled;
};

export const hasAnyModuleEnabled = (modules: string[]) => {
	const authUser: IAuthenticateUserResponse = getAuthUser();
	for (let i = 0; i < modules.length; i++) {
		const feature = find(authUser?.tenantFeatures, { module: modules[i] });
		if (feature?.enabled) {
			return true;
		}
	}
	return false;
};
